/* eslint-disable @typescript-eslint/no-explicit-any */
import type Highcharts from "highcharts";
declare module "highcharts" {
  interface Options {
    deferSeriesRender?: boolean;
  }
}

export default function deferSeriesRender(H: typeof Highcharts) {
  H.wrap(
    H.Chart.prototype,
    "renderSeries",
    function (this: Highcharts.Chart, proceed: any, ...args: unknown[]) {
      if (this.options.deferSeriesRender) {
        window.requestIdleCallback(() => {
          if (this.renderer) proceed.apply(this, args);
        });
      } else {
        proceed.apply(this, args);
      }
    },
  );
}
